import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import * as ReactDOM from 'react-dom';
var key = 'ellipsis-text';
var EllipsisText = /** @class */ (function (_super) {
    __extends(EllipsisText, _super);
    function EllipsisText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.state = {
            hasOverflowingChildren: false,
            text: ''
        };
        _this.getRelevantElement = function (el) {
            if (_this.props.forceTooltip && el) {
                return el.querySelector('.popper-target > .text') || el;
            }
            else {
                if (_this.props.tooltipBody && _this.props.ellipsisWrapperClassName) {
                    return el.closest(".text.".concat(_this.props.ellipsisWrapperClassName)) || el;
                }
                return el;
            }
        };
        _this.updateOverflow = function (e) {
            var el = _this.getRelevantElement(e.target);
            if (el) {
                var _a = _this.state, hasOverflowingChildren = _a.hasOverflowingChildren, text = _a.text;
                var hasEllipsis = _this.props.maxRows ? el.scrollHeight > el.clientHeight : el.scrollWidth > el.clientWidth;
                if (!hasOverflowingChildren && hasEllipsis) {
                    _this.setState({ hasOverflowingChildren: true });
                    if (_this.props.onEllipsisChange) {
                        _this.props.onEllipsisChange(true);
                    }
                    if (el.textContent !== text) {
                        _this.setState({ text: el.textContent || '' });
                    }
                }
                else {
                    if (_this.props.onEllipsisChange && hasOverflowingChildren && !hasEllipsis) {
                        _this.props.onEllipsisChange(false);
                    }
                    _this.setState({ hasOverflowingChildren: false });
                }
            }
        };
        _this.loadElement = function (e) {
            // cpmsp;
            _this.element = e && ReactDOM.findDOMNode(e);
            if (_this.element && !_this.state.hasOverflowingChildren) {
                setTimeout(function () {
                    _this.updateOverflow({ target: _this.element });
                }, 100);
            }
        };
        _this.componentDidUpdate = function (prevProps) {
            if (_this.state.hasOverflowingChildren && prevProps.tooltipText !== _this.props.tooltipText) {
                _this.setState({ hasOverflowingChildren: false });
            }
            // const el = this.getRelevantElement(this.element);
            // if (el && el.textContent !== this.state.text) {
            // 	this.setState({ text: el.textContent || '' });
            // }
        };
        return _this;
    }
    EllipsisText.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var hasOverflowingChildren = state.hasOverflowingChildren, text = state.text;
        var children = this.props.children;
        var showTooltip = this.props.noTooltip === true ? false : this.props.forceTooltip || hasOverflowingChildren;
        var maxRowsCn = props.maxRows ? "ellipsis-".concat(props.maxRows, "-rows") : '';
        var className = namespacedClassnames(key, props.className, maxRowsCn, {
            'tooltip-visible': showTooltip,
            'using-span': props.useSpan
        });
        var popperTargetClassName = function () {
            if (props.popperTargetClassName) {
                return props.maxRows ?
                    "".concat(props.popperTargetClassName, " ").concat(maxRowsCn) :
                    props.popperTargetClassName;
            }
            else if (props.maxRows) {
                return maxRowsCn;
            }
            else {
                return undefined;
            }
        };
        return showTooltip ? (React.createElement(Tooltip, { ref: this.loadElement, relativeToBody: props.tooltipRelativeToBody, className: className, body: props.tooltipText || props.tooltipBody || text, forceVisible: props.forceTooltipVisible, direction: props.direction, popperTargetClassName: popperTargetClassName(), align: 'left', dismissTooltipOnHover: props.dismissTooltipOnHover }, children)) : (React.createElement("div", { className: className, onMouseEnter: this.updateOverflow }, this.props.children));
    };
    return EllipsisText;
}(React.PureComponent));
export { EllipsisText };
//# sourceMappingURL=ellipsis-text.js.map